import React from 'react';

interface ModalContextValue {
  onHide?: (value: boolean) => void;
}

const ModalContext = React.createContext<ModalContextValue | null>(null);

export default ModalContext;
